import React from "react";
import ContentResgistroUsuario from "./ContentResgistroUsuario";

const RegistrarUsuario = () => {
  return (
    <div>
      <ContentResgistroUsuario />
    </div>
  );
};

export default RegistrarUsuario;
